// 🔧 demo_report.js
// ✅ Purpose: Creates standardized reports for LGV Demo Engine runs
// ✅ Features:
// - Gives every demo run a consistent report structure
// - Tracks selected industry, intent, package, voting engine, and size
// - Tracks created data counts as builders are added
// - Supports public and manager URLs
// - Designed to expand naturally for Phase 2 add-on builders
// - Fully block-commented for clarity and future devs

export const createInitialDemoReport = ({ demoConfig, industryTemplate } = {}) => {
  return {
    createdAt: new Date().toISOString(),

    config: {
      industry: demoConfig?.industry || "car_show",
      industryLabel: industryTemplate?.label || "Car Show",
      intent: demoConfig?.intent || "internal_testing",
      package: demoConfig?.package || "core",
      votingEngine:
        industryTemplate?.scoring?.votingType ||
        demoConfig?.votingEngine ||
        "points",
      size: demoConfig?.size || "small",
    },

    created: {
      event: false,
      categories: 0,
      entries: 0,
      users: 0,
      votes: 0,
      winnersReady: false,
      maps: false,
      schedule: false,
      seo: false,
      homepage: false,
    },

    addOns: {
      sponsors: 0,
      volunteers: 0,
      vendors: 0,
      tickets: 0,
      auctionItems: 0,
      merchItems: 0,
      passportStops: 0,
    },

    links: {
      publicUrl: "",
      managerUrl: "",
    },

    messages: [],
  };
};

export const finalizeCoreDemoReport = ({ report, result } = {}) => {
  return {
    ...report,

    created: {
      ...report.created,
      event: true,
      winnersReady: true,
      homepage: true,
    },

    links: {
      publicUrl: result?.eventSlug ? `/${result.eventSlug}` : "",
      managerUrl: (result?.eventSlug || result?.eventId)
        ? `/event/${result.eventSlug || result.eventId}`
        : "",
    },

    messages: [
      ...(report.messages || []),
      "Core demo event created through existing demo helper.",
    ],
  };
};
